module.exports = __webpack_public_path__ + "static/media/lightbuild-unsplash.0132be01.jpg";